import { takeLatest, put, select, call } from 'redux-saga/effects'
import { gymIconPlaceholder } from '@assets'
import fetchGyms from '@client/services/gyms'

import { actions, types } from '@store/ducks/gym'
import { addMarkersSuccess } from '@store/ducks/map'
import { setAppLoading, setAppUpdated } from '@store/ducks/application'

function getBasicGymsInfos(gyms) {
  return gyms.map(item => ({
    id: item.gym.id,
    title: item.gym.title,
    position: {
      lat: item.gym.location.lat,
      lng: item.gym.location.lon,
    },
    selected: false,
  }))
}

function getPanelGymsInfos(fullInfoGyms) {
  return fullInfoGyms.map(item => ({
    id: item.gym.id,
    title: item.gym.title,
    position: {
      lat: item.gym.location.lat,
      lng: item.gym.location.lon,
    },
    photoUrl: item.gym.images.logo
      ? item.gym.images.logo.filename_url
      : gymIconPlaceholder,
    rating: item.gym.rating,
    slug: item.gym.slug,
    activities: item.gym.activity_categories.map(
      activity => activity.activities[0].title.pt
    ),
  }))
}

function* selectGymSaga({ selectedGym }) {
  const markers = yield select(state => state.map.markers)
  const gyms = yield select(state => state.gym.gyms)
  const newMarkers = markers.map(marker => ({
    ...marker,
    selected: marker.id === selectedGym.id,
  }))
  yield put(addMarkersSuccess(newMarkers))
  const fullGym = gyms.find(gym => gym.id === selectedGym.id)
  yield put(actions.selectGymSuccess(fullGym))
}

function* unselectGymSaga() {
  const markers = yield select(state => state.map.markers)
  const newMarkers = markers.map(marker => ({
    ...marker,
    selected: false,
  }))
  yield put(addMarkersSuccess(newMarkers))
  yield put(actions.unselectGymSuccess())
}

function* gymSearchSaga() {
  const filter = yield select(({ gym }) => gym.filter)

  const data = {
    maxPrice: filter.plan.maxPrice,
    lat: filter.geolocation.lat,
    lng: filter.geolocation.lng,
  }

  yield put(setAppLoading('GymSearchMap'))
  try {
    const { data: result } = yield call(fetchGyms, data)
    const markers = getBasicGymsInfos(result.near_gyms)
    const gyms = getPanelGymsInfos(result.near_gyms)

    yield put(addMarkersSuccess(markers))
    yield put(actions.addGymsSuccess(gyms))
    yield put(actions.unselectGymSuccess())
    yield put(setAppUpdated())
  } catch (error) {
    yield put(setAppUpdated())
  }
}

function* addGeolocationFilterSaga({ geolocation }) {
  yield put(actions.addGymSearchGeolocationFilterSuccess(geolocation))
}

function* addPlanFilterSaga({ plan }) {
  yield put(actions.addGymSearchPlanFilterSuccess(plan))
}

export default function*() {
  yield takeLatest(types.SELECT_GYM_REQUEST, selectGymSaga)
  yield takeLatest(types.UNSELECT_GYM_REQUEST, unselectGymSaga)
  yield takeLatest(
    types.ADD_GEOLOCATION_FILTER_REQUEST,
    addGeolocationFilterSaga
  )
  yield takeLatest(types.ADD_PLAN_FILTER_REQUEST, addPlanFilterSaga)
  yield takeLatest(types.GYM_SEARCH_REQUEST, gymSearchSaga)
}
